import { render, staticRenderFns } from "./LeaveBenefitsDetails.vue?vue&type=template&id=cb2a15d4&scoped=true"
import script from "./LeaveBenefitsDetails.vue?vue&type=script&lang=js"
export * from "./LeaveBenefitsDetails.vue?vue&type=script&lang=js"
import style0 from "./LeaveBenefitsDetails.vue?vue&type=style&index=0&id=cb2a15d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2a15d4",
  null
  
)

export default component.exports